import { mapState } from 'vuex';
export default {
  name: 'ViewScheduledExportsScheduledExportsList',
  data() {
    return {
      search: '',
      selectedAccounts: [],
      accountFilterReady: false,
      showTaskDialog: false,
      jobObject: null,
      copyMode: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])
  },
  methods: {
    updateList() {
      this.$refs.list.fetchJobs();
    },
    showDetails(item, copyMode) {
      this.jobObject = item;
      this.showTaskDialog = true;
      this.copyMode = copyMode;
    }
  }
};